import React, { StrictMode } from 'react';
import * as ReactDOM from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import './faroInstrumentation';

import App from './app';
import config from './config';
import { AnalyticsProvider } from './hooks/useAnalytics';
import Auth0ProviderWithHistory from './components/Auth0ProviderWithHistory/Auth0ProviderWithHistory';
import { ConfigProvider } from './hooks/useConfig';

const queryClient = new QueryClient();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
);
root.render(
  <StrictMode>
    <ConfigProvider config={config}>
      <AnalyticsProvider>
        <QueryClientProvider client={queryClient}>
          <Auth0ProviderWithHistory>
            <App />
          </Auth0ProviderWithHistory>
        </QueryClientProvider>
      </AnalyticsProvider>
    </ConfigProvider>
  </StrictMode>,
);
